import { Phone, Star, ArrowRight, Shield, Clock, Award } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import heroDesktop from "@/assets/hero-plumbing.webp";
import heroMobile from "@/assets/hero-mobile.webp";

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-end md:items-center justify-center pb-16 pt-28 md:pt-20 md:pb-0 overflow-hidden">
      {/* Background Image - Critical LCP element with explicit dimensions */}
      <div className="absolute inset-0 z-0">
        <picture>
          <source media="(min-width: 768px)" srcSet={heroDesktop} width="1920" height="1080" />
          <img
            src={heroMobile}
            alt="Fischer McKenzie licensed plumber providing expert plumbing services in Gulf Shores Baldwin County Alabama"
            className="w-full h-full object-cover md:object-center object-top"
            width="750"
            height="1334"
            fetchPriority="high"
            decoding="sync"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-hero" />
        <div className="absolute inset-0 line-pattern opacity-50" />
      </div>

      {/* Content - No animation delay for faster FCP */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          {/* Main Headline */}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 leading-[1.1] animate-[fadeUp_0.5s_ease-out_forwards]">
            Your Trusted{" "}
            <span className="text-gradient-sky">Plumber in Baldwin County, AL</span>
            <span className="block text-xl md:text-3xl lg:text-4xl mt-2 text-foreground/80">Serving Gulf Shores, Orange Beach, Foley, Fairhope, Daphne & Beyond — 24/7</span>
          </h1>

          <p className="text-sm md:text-lg text-foreground/85 mb-6 md:mb-8 max-w-2xl leading-relaxed animate-[fadeUp_0.5s_ease-out_0.1s_forwards] opacity-0">
            Onyx Professional Plumbing brings expert craftsmanship to every job — from emergency calls and water heater installs to full remodels. We proudly serve Gulf Shores, Orange Beach, Foley, Fairhope, Daphne, Spanish Fort, and all of Baldwin County.
          </p>

          {/* Trust Badges Row */}
          <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-6 md:mb-8 animate-[fadeUp_0.5s_ease-out_0.15s_forwards] opacity-0">
            <div className="flex items-center gap-1.5 bg-card/60 backdrop-blur-sm border border-border/50 rounded-full px-3 py-1.5 text-sm">
              <Shield className="h-4 w-4 text-primary" />
              <span className="text-foreground/90">License MP-4174</span>
            </div>
            <div className="flex items-center gap-1.5 bg-card/60 backdrop-blur-sm border border-border/50 rounded-full px-3 py-1.5 text-sm">
              <Award className="h-4 w-4 text-primary" />
              <span className="text-foreground/90">Licensed Pros</span>
            </div>
            <div className="flex items-center gap-1.5 bg-card/60 backdrop-blur-sm border border-border/50 rounded-full px-3 py-1.5 text-sm">
              <Clock className="h-4 w-4 text-primary" />
              <span className="text-foreground/90">24/7 Emergency</span>
            </div>
            <div className="flex items-center gap-1 bg-card/60 backdrop-blur-sm border border-border/50 rounded-full px-3 py-1.5 text-sm">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-3.5 w-3.5 fill-primary text-primary" />
              ))}
              <span className="text-foreground/90 ml-1">5.0</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start gap-4 animate-[fadeUp_0.5s_ease-out_0.25s_forwards] opacity-0">
            <Button variant="hero" size="xl" asChild>
              <a href="tel:251-504-4452">
                <Phone className="h-5 w-5" />
                Call Now: (251) 504-4452
              </a>
            </Button>
            <Button variant="outlineBrand" size="xl" asChild>
              <Link to="/services">
                View Services
                <ArrowRight className="h-5 w-5" />
              </Link>
            </Button>
          </div>
          <p className="text-sm text-foreground/75 mt-4 animate-[fadeUp_0.5s_ease-out_0.3s_forwards] opacity-0">
            Free Estimates • No Overtime Charges • Owner-Operated
          </p>
        </div>
      </div>

    </section>
  );
};
